import { useMutation, useQuery } from "react-query"
import { useMainContext } from "../../../modules/Dashboard"
import { normalFetch } from "../../../core/services/fetch-api/get"
import { useQueryContext } from "../../../core/contexts/query"
import { deleteApi } from "../../../core/services/fetch-api/delete"
import { postApiWithToken } from "../../../core/services/fetch-api/post"

const useInviteCodesQuery = (page = 1) => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery(
		'fetch-invite-codes',
		() => normalFetch(token, `affiliates?page=${page}&limit=10`),
		{
			select: (res) => res.data,
			refetchOnWindowFocus: false,
		}
	)
}

const useInviteTreeQuery = (page = 1) => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery('fetch-invite-tree', () => normalFetch(token, `affiliates/users`), {
		enabled: !!token,
		select: (res) => res.data,
		refetchOnWindowFocus: false,
	})
}

const useDeleteInviteCodeMutation = ({ onSuccess }) => {
	const {
		profile: { token },
	} = useMainContext()
	const { queryClient, setToast } = useQueryContext()

	return useMutation(
		'delete-invite-code',
		(id) => deleteApi(token, `affiliates/${id}`),
		{
			onSuccess: () => {
				onSuccess()
				queryClient.invalidateQueries('fetch-invite-codes')
				setToast({
					show: true,
					message: 'op-success'
				})
			},
		}
	)
}

const useCreateInviteCodeMutation = () => {
	const {
		profile: { token },
	} = useMainContext()
	const { queryClient, setToast } = useQueryContext()

	return useMutation(
		'create-invite-code',
		(data) => {
			return postApiWithToken(data, token, `affiliates`)
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('fetch-invite-codes')
				setToast({
					show: true,
					message: 'op-success'
				})
			},
		}
	)
}

export {
	useInviteCodesQuery,
	useDeleteInviteCodeMutation,
	useCreateInviteCodeMutation,
	useInviteTreeQuery,
}
